import { styled } from '@mui/material';
import MUIBox from '@mui/material/Box';
import MUIDivider from '@mui/material/Divider';
import MUITypography from '@mui/material/Typography';

export const OrderDetailsHeader = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  justifyContent: 'space-between',
  color: theme.palette.grey[900],
  marginBottom: theme.spacing(4),
  gap: theme.spacing(2),

  [theme.breakpoints.up(1024)]: {
    flexDirection: 'row',
  },
}));

export const OrderDetailsTitleContainer = styled(MUIBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
}));

export const OrderActionsContainer = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: theme.spacing(1),

  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(3),
  },
}));

export const OrderDetailsButtonsContainer = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'flex-start',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
}));

export const ExportButtonContainer = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(2),
  },
}));

export const OrderDetailsMainContent = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  flexGrow: 1,
  flexWrap: 'wrap',
  color: theme.palette.grey[900],
  marginBottom: theme.spacing(10),
  gap: theme.spacing(4),

  // Ugly fix for container margin changing at 'md' breakpoint
  [theme.breakpoints.between('md', 955)]: {
    gap: '0.5vw',
  },
}));

export const OrderDetailsPanel = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexBasis: '360px',
  minWidth: '360px',
  border: `1px solid  ${theme.palette.grey[900]}`,
  overflow: 'auto',
  borderRadius: theme.shape.borderRadius,

  msOverflowStyle: 'none' /* IE and Edge */,
  scrollbarWidth: 'none' /* Firefox */,

  /* Chrome Safari Opera */
  '&::-webkit-scrollbar': {
    display: 'none',
  },

  [theme.breakpoints.up('md')]: {
    flexGrow: 0,
    order: -1,
  },
}));

export const OrderItemsPanel = styled(MUIBox)`
  display: flex;
  flex-direction: column;
  flex-grow: 100;
  min-width: 360px;
  max-height: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.grey[900]};
`;
export const OrderDetailsSection = styled(MUIBox)`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
export const OrderDetailsPanelTitle = styled(MUITypography)`
  margin: 2rem 2rem 0 2rem;
`;
OrderDetailsPanelTitle.defaultProps = { variant: 'h6', fontWeight: 'bold' };

export const OrderDetailsData = styled(MUIBox)`
  display: flex;
  flex-direction: column;
  margin: 2rem 2rem 1rem 2rem;
`;

export const OrderDetailsDataRow = styled(MUIBox)`
  display: flex;
`;

export const OrderDetailsDataHeader = styled(MUITypography)`
  margin: 0.15rem 0;
  width: 50%;
`;

export const OrderDetailsDataCell = styled(MUITypography)`
  width: 50%;
  margin: 0.15rem 0;
  overflow-wrap: break-word;
`;
OrderDetailsDataCell.defaultProps = { fontWeight: 'bold' };

export const OrderDetailsDivider = styled(MUIDivider)`
  width: 90%;
  height: 2px;
  align-self: center;
  border-color: ${({ theme }) => theme.palette.grey[300]};
`;

export const TotalDivider = styled(MUIDivider)`
  height: 2px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.grey[900]};
  align-self: flex-end;
`;
